import React from 'react';
import { FormattedMessage } from 'react-intl';
import config from 'appconfig';
import { LICENSE_STARTER } from 'model/hams/LicenseType';
import { jiraAddOnKeys, serviceDeskAddOnKeys } from 'data/products/keys';
import t from 'modules/i18n/intl';

const hereLink = (chunks) => (
  <a href="https://confluence.atlassian.com/migration/jira-7/server_licensing-faqs">{chunks}</a>
);

const JSDLink = (chunks) => (
  <a href={`${config.wacUrl}/purchase/product/jira-servicedesk`}>{chunks}</a>
);

const companyContactLink = (chunks) => <a href={config.companyContact}>{chunks}</a>;

const NonPubliclyAvailableAddOnMessage = ({ accountDetails }) => {
  const productPackage = accountDetails.merchandise.productPackage || accountDetails.productPackage;
  const { key } = productPackage;
  const { details } = accountDetails.merchandise;

  const isJiraAddOn = jiraAddOnKeys.includes(key);
  const isServiceDeskAddOn = serviceDeskAddOnKeys.includes(key);

  if (isJiraAddOn) {
    return t(
      {
        id: 'mac.licenses.jira.addon',
        defaultMessage:
          "We've made some exciting changes to JIRA! Find out what this means for your team <hereLink>here</hereLink>",
      },
      {
        hereLink,
      },
    );
  }
  if (isServiceDeskAddOn) {
    if (details.licenseType === LICENSE_STARTER) {
      return t(
        {
          id: 'mac.licenses.jsd.addon.starter',
          defaultMessage:
            'To upgrade or renew, <link>purchase a new license</link> at the desired tier.',
        },
        {
          link: JSDLink,
        },
      );
    }
    return t(
      {
        id: 'mac.licenses.jsd.addon.non-starter',
        defaultMessage: 'Ready to Renew or Upgrade? Please <link>contact us</link>.',
      },
      {
        link: companyContactLink,
      },
    );
  }
  return (
    <FormattedMessage
      id="mac.licenses.non-available.addon"
      defaultMessage="This app cannot be upgraded or renewed through Atlassian. Please contact the vendor directly."
    />
  );
};

export default NonPubliclyAvailableAddOnMessage;
